export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/staff-register/:pageId',
        component: () => import('@/views/page/company/sdm/staff-register/List.vue'),
        name: 'staff-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/dealer-register/:pageId',
        component: () => import('@/views/page/company/sdm/dealer-register/register/Index.vue'),
        name: 'dealer-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/add-dealer/:pageId',
        component: () => import('@/views/page/company/sdm/dealer-register/Add.vue'),
        name: 'add-dealer',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sdm-sales-order/:pageId',
        component: () => import('@/views/page/company/sdm/order-sales/AddOrder.vue'),
        name: 'sdm-sales-order',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sdm-sales-order-list/:pageId',
        component: () => import('@/views/page/company/sdm/order-sales/List.vue'),
        name: 'sdm-sales-order-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-allocation/:pageId',
        component: () => import('@/views/page/company/sdm/sales-allocation/List.vue'),
        name: 'sales-allocation',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-commissions/:pageId',
        component: () => import('@/views/page/company/sdm/sales-commision/SaleCommission.vue'),
        name: 'sales-commissions',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-commission-payout/:pageId',
        component: () => import('@/views/page/company/sdm/sale-commission-payout/List.vue'),
        name: 'sales-commission-payout',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-commissions-old/:pageId',
        component: () => import('@/views/page/company/sdm/sales-commision/List.vue'),
        name: 'sales-commissions-old',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/incentive-process/:pageId',
        component: () => import('@/views/page/company/sdm/incentive-process/List.vue'),
        name: 'incentive-process',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/incentive-setup/:pageId',
        component: () => import('@/views/page/company/hospital/incentive-setup/List.vue'),
        name: 'incentive-setup',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/incentive-setup-add/:pageId',
        component: () => import('@/views/page/company/hospital/incentive-setup/Add.vue'),
        name: 'incentive-setup-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/pos-bill-marketing/:pageId',
        component: () => import('@/views/page/company/sdm/pos/PosInvoice.vue'),
        name: 'pos-bill-marketing',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/incentive-payment-voucher/:pageId',
        component: () => import('@/views/page/company/sdm/incentive-payment/IncentivePayment.vue'),
        name: 'incentive-payment-voucher',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/incentive-payment-voucher/:pageId/edit/:voucherId',
        component: () => import('@/views/page/company/sdm/incentive-payment/IncentivePayment.vue'),
        name: 'incentive-payment-voucher-edit',
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/incentive-payment-voucher-list/:pageId',
        component: () => import('@/views/page/company/sdm/incentive-payment/List.vue'),
        name: 'incentive-payment-voucher-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sdm-commission-profile/:pageId',
        component: () => import('@/views/page/company/sdm/commission-profile/SdmCommissionProfile.vue'),
        name: 'sdm-commission-profile',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/marketing-team-collection-report/:pageId',
        component: () => import('@/views/page/company/sdm/collection-report/MarketingTeamCollectionReport.vue'),
        name: 'marketing-team-collection-report',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/shareholder-collection-report/:pageId',
        component: () => import('@/views/page/company/sdm/collection-report/ShareholderCollectionReport.vue'),
        name: 'shareholder-collection-report',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/installment-due-report/:pageId',
        component: () => import('@/views/page/company/sdm/collection-report/InstallmentDueReport.vue'),
        name: 'installment-due-report',
        meta: {
            requiresAuth: true
        }
    },
]